import { ChainEnhanced, useChainEnhanced } from '@cyberkongz/ui-blockchain';
import { useMemo } from 'react';

const API_BASE_URL = 'https://api.cyberkongz.com';
const API_TESTNET_BASE_URL = 'https://api-testnet.cyberkongz.com';

function getApiBaseUrl(chain?: ChainEnhanced) {
  return (
    process.env.NEXT_PUBLIC_BASE_API_URL || (chain?.testnet ? API_TESTNET_BASE_URL : API_BASE_URL)
  );
}

export function useApiBaseUrl() {
  const { chain } = useChainEnhanced();

  const _API_BASE_URL = useMemo(() => getApiBaseUrl(chain), [chain]);

  return {
    API_BASE_URL: _API_BASE_URL,
  };
}

// helper if routes are used in server side environment where hooks are not available
export function getSharedApiRoutes(_apiBaseUrl?: string) {
  const apiBaseUrl = _apiBaseUrl || getApiBaseUrl();

  return {
    GET_KONG: (id: number) => `${apiBaseUrl}/kong/${id}`,
    GET_KONG_BABY_IMAGE: (genes: string) => `${apiBaseUrl}/kong/baby-image/${genes}`,
    GET_KONG_VX: (id: number) => `${apiBaseUrl}/kong-vx/${id}`,
    GET_KONG_GENKAI: (id: number) => `${apiBaseUrl}/kong-genkai/${id}`,
    POST_ASSESTS_DOWNLOAD: `${apiBaseUrl}/assets-download`,
  };
}

export function useSharedApiRoutes() {
  const { API_BASE_URL } = useApiBaseUrl();

  const SHARED_API_ROUTES = useMemo(() => getSharedApiRoutes(API_BASE_URL), [API_BASE_URL]);

  return { SHARED_API_ROUTES };
}
